import { render, staticRenderFns } from "./listdeduction.vue?vue&type=template&id=fa4c89c6&"
import script from "./listdeduction.vue?vue&type=script&lang=js&"
export * from "./listdeduction.vue?vue&type=script&lang=js&"
import style0 from "./listdeduction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports